import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  inject,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FlightSearchService } from '../../services/flight-search/services/flight-search.service';
import { SharedService } from '../../services/shared.service';

export interface flightType {
  type: string;
  label: string;
}

@Component({
  selector: 'app-flight-search-box',
  templateUrl: './flight-search-box.component.html',
  styleUrls: ['./flight-search-box.component.scss'],
})
export class FlightSearchBoxComponent implements OnInit {
  @Input() airlineLogo: string | null = null; // Initialize with null
  public flightSearch = inject(FlightSearchService);
  public translate = inject(TranslateService);
  sharedService = inject(SharedService);
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private fb: FormBuilder,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.flightSearch.searchFlight = this.fb.group({
      flightType: ['OneWay', Validators.required],
      Flights: this.fb.array([]),
      passengers: this.fb.group({
        adults: [1, [Validators.required, Validators.min(1)]],
        children: [0, [Validators.required, Validators.min(0)]],
        infants: [0, [Validators.required, Validators.min(0)]],
      }),
    });

    if (this.isBrowser) {
      const form = JSON.parse(localStorage.getItem('form') as string);

      if (form) {
        const cityPattern = form.Flights[0].departing;
        const pattern = /,/;

        if (!pattern.test(cityPattern)) {
          localStorage.removeItem('form');
        }
      }

      // Initialize the search form with the retrieved form data
      this.flightSearch.initSearchForm(form);

      this.flightSearch.flightsArray.controls.forEach((flightItem, i) => {
        if(this.sharedService.landingAirports[i]) {
          const selectedAirport = this.sharedService.landingAirports[i][this.sharedService.lang].cityName + ',' + this.sharedService.landingAirports[i][this.sharedService.lang].airportCode;

          flightItem.get('landing')?.setValue(selectedAirport);
        }
        
        if(this.sharedService.departingAirports[i]) {
          const selectedAirport = this.sharedService.departingAirports[i][this.sharedService.lang].cityName + ',' + this.sharedService.departingAirports[i][this.sharedService.lang].airportCode;

          flightItem.get('departing')?.setValue(selectedAirport);
        }

      })
    }
  }
}
